import { ReactElement } from 'react';

import { Portal } from '@dreryk/react-components';

type PrescriptionStatusBoxProps = {
   readonly prescriptionId: string;
};

export const PrescriptionStatusBox = (props: PrescriptionStatusBoxProps): JSX.Element => (
   <Portal.Container id={props.prescriptionId} testId={'prescriptionStatusBox'} />
);

type PrescriptionStatusBoxPortalProps = {
   readonly children: ReactElement;
   readonly prescriptionId: string;
};

export const PrescriptionStatusBoxPortal = (props: PrescriptionStatusBoxPortalProps): JSX.Element => (
   <Portal containerId={props.prescriptionId}>{props.children}</Portal>
);
